module.exports = __webpack_public_path__ + "static/img/1.57efcdf8.jpg";